<template>
    <div>
        <v-row>
            <v-col cols="12" class="d-flex my-2">
                <v-btn color="primary" dark @click="dialog=true" class="mr-1">{{ $t('startGrids.add-participant')}}</v-btn>
                <v-btn color="primary" dark @click="print">{{ $t('common.print')}}</v-btn>
            </v-col>
        </v-row>
        <v-data-table
            :headers="headersClass"
            :items="itemsClasses"
            item-key="keyItem"
            :footer-props="{
                'items-per-page-text': $t('dataTable.rowsPerPageText'),
                'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
            }"
            :no-data-text="$t('dataTable.noDataText')"
            :headerProps="{
                'sort-by-text': $t('dataTable.sortByText')
            }"
        >
            <template v-slot:item.actions="{ item }">
                <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
                <v-icon small @click="confirmDelete(item)">mdi-delete</v-icon>
            </template>
        </v-data-table>
        <v-dialog v-model="dialog" max-width="600px">
            <v-form ref="formAddParticipant">
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ titleModal }}</span>
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12">
                                <v-select
                                    v-if="!bandEdit"
                                    outlined dense 
                                    :label="$t('startGrids.participant')"
                                    :items="participants"
                                    v-model="participant"
                                    item-value="id"
                                    item-text="participant"
                                    return-object
                                    :rules="participantRules"
                                    :no-data-text="$t('common.no_data')"
                                >
                                <template slot="selection" slot-scope="data">
                                    {{ data.item.number }}, {{ data.item.raceName}}, {{ data.item.participant }}
                                </template>
                                <template slot="item" slot-scope="data">
                                    {{ data.item.number }}, {{ data.item.raceName}}, {{ data.item.participant }}
                                </template>
                                </v-select>
                            </v-col>
                            <v-col cols="12">
                                <v-select
                                    outlined dense 
                                    :label="$t('startGrids.start_row')"
                                    :items="itemsRows"
                                    v-model="startRow"
                                    :rules="startRowRules"
                                    :no-data-text="$t('common.no_data')"
                                >
                                </v-select>
                            </v-col>
                            <v-col cols="12">
                                <v-select
                                    outlined dense 
                                    :label="$t('startGrids.position')"
                                    :items="itemsRows"
                                    v-model="position"
                                    :rules="positionRules"
                                    :no-data-text="$t('common.no_data')"
                                >
                                </v-select>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="darken-1" dark small @click="close">{{ $t('common.form.cancel') }}</v-btn>
                        <v-btn color="darken-1" dark small @click="save" class="mr-2">{{ $t('common.form.save') }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <SGSNotificationAlert v-if="dialogAlert" :notificationMessage="alertMessage" @cancel="closeAlert" type='error'/>
        <SGSNotificationConfirm v-if="dialogNotification" :notificationMessage="$t('common.confirm-delete')" 
        @cancel="dialogNotification=false;" @agree="deleteItem" type='warning' :acept="$t('common.form.delete')" :reject="$t('common.form.cancel')"/>
    </div>
</template>

<script>
import { apiCalls } from "@/mixins/apiCalls.js";
import SGSNotificationAlert from "@/components/custom/notification/NotificationAlert.vue";
import SGSNotificationConfirm from "@/components/custom/notification/NotificationConfirm.vue";

export default {
    mixins: [apiCalls],
    components: { SGSNotificationAlert, SGSNotificationConfirm },
    props: {
        item: { type: Object, default: () => {} }, participants: { type: Array, default: () => [] }, 
        index: { type: Number, default: 0 }, subIndex: { type: Number, default: 0 },
        classIdArray: { type: Array, default: () => [] }, configId: { type: Number, default: 0 },
        raceId: { type: Number, default: 0 }, bandReopen: { type: Boolean, default: false },
        refName: { type: String, default: '' }
    },
    data() {
        return {
            itemsClasses: [],
            dialogAlert: false,
            alertMessage: '',
            dialogNotification: false,
            dialog: false,
            bandEdit: false,
            participant: null,
            itemsRows: [],
            startRow: null,
            position: null,
            reopenEdition: false,
            selectedItem: null,
            itemDelete: null
        };
    },
    computed: {
        headersClass() {
            return [
                {   text: this.$t("startGrids.start-row"), value: 'startRow'   },
                {   text: this.$t("startGrids.position"), value: 'position'    },
                {   text: this.$t("startGrids.race-number"), value: 'number'    },
                {   text: this.$t("startGrids.first-name"), value: 'firstname' },
                {   text: this.$t("startGrids.last-name"), value: 'lastname'   },
                {   text: this.$t("startGrids.brand"), value: 'brand'  },
                {   text: this.$t("startGrids.actions"), value: 'actions' }
            ];
        },
        titleModal() {
            return this.bandEdit ? this.$t('startGrids.edit-participant') : this.$t('startGrids.add-participant');
        },
        participantRules() {
            return [
                (val) => (val || "").toString().length > 0 || this.$t('startGrids.required-participant')
            ];
        },
        startRowRules() {
            return [
                (val) => (val || "").toString().length > 0 || this.$t('startGrids.required-start-row')
            ];
        },
        positionRules() {
            return [
                (val) => (val || "").toString().length > 0 || this.$t('startGrids.required-position')
            ];
        }
    },
    created() {
        this.loadTable();
        this.loadRows();
    },      
    methods: {
        async loadTable() {
            const data = {
                configId: this.item.configId,
                raceId: this.item.raceId,
                raceClassesId: this.item.classIdArray
            };
            const response = await this.postApi('/api/v1/promoter/startGrid/getParticipantsDT', data);
            
            if(response.success) {
                this.itemsClasses = (response.message || []).map((el,i) => {
                    return { ...el, keyItem: `item-${this.index}-${this.subIndex}-${i}`};
                });
            }
        },
        editItem(item) {
            this.bandEdit = true;
            this.dialog = true;
            this.selectedItem = item;
            this.startRow = this.selectedItem.startRow;
            this.position = this.selectedItem.position;
        },
        async confirmDelete(item) {
            this.itemDelete = item
            this.$emit('confirmDeleteForClass', { refName: this.refName });
        },
        closeAlert() {
            this.dialogAlert=false;
        },
        async deleteItem() {
            if(this.itemDelete) {
                const response = await this.deleteApi('/api/v1/promoter/startGrid/deleteParticipants/' + this.itemDelete.raceStartGridId);
                
                if(response && response.success) {
                    this.loadTable();
                    this.$emit("closeDelete");
                } else {
                    this.$emit("showError", { message: this.$t('common.general_error') });
                }
            }
        },
        close() {
            this.dialog = false;
        },
        async save() {
           if(!this.$refs.formAddParticipant.validate()) {
               return;
           }
           if(this.classIdArray.length > 0) {
               let data = {};
               if(!this.bandEdit) {
                    data = {
                        classId: this.classIdArray[0],
                        configId: this.configId,
                        raceId: this.raceId,
                        participantId: this.participant.id,
                        startRow: this.startRow,
                        position: this.position
                    };
               } else {
                    data = {
                        classId: this.selectedItem.id,
                        startGridId: this.selectedItem.raceStartGridId,
                        raceId: this.raceId,
                        startRow: this.startRow,
                        position: this.position
                    };
               }
                let response = undefined;
                if(!this.bandEdit) {
                    response = await this.postApi('/api/v1/promoter/startGrid/insertParticipants', data);
                } else {
                    response = await this.putApi('/api/v1/promoter/startGrid/updateParticipants', data);
                } 
                
                this.dialog = false;
                if(response && response.success) {
                    this.reopenEdition = false;
                    this.loadTable();
                } else if(response) {
                    let message = this.$t('common.general_error');
                    this.reopenEdition = false;
                    if(Array.isArray(response.error)) {
                        message = this.$t('common.request.'+response.error[0]);
                        this.reopenEdition = true;
                    } else if(typeof response.error == 'string') {
                        message = this.$t('common.request.'+response.error);
                        this.reopenEdition = true;
                    } else if(response.message) {
                        message = this.$t('common.general_error');
                        this.reopenEdition = true;
                        if(Array.isArray(response.message) && response.message.length > 0) {
                            message = this.$t('common.request.'+response.message[0]);
                            this.reopenEdition = true;
                        } else if(typeof response.message == 'string') {
                            message = this.$t('common.request.'+response.message);
                            this.reopenEdition = true;
                        }
                    }
                    this.$emit("showError", { message });
                } else {
                    this.$emit("showError", { message: this.$t('common.general_error') });
                }
           } else {
               this.dialog = false;
               this.$emit("showError", { message: this.$t('common.general_error') });
           }
           
        },
        loadRows() {
            for(let i = 1; i <= 1000; i++) {
                this.itemsRows.push(i);
            }
        },
        print() {
            const routeData = this.$router.resolve({
                name: 'StartGridsPrint', 
                params: { id: this.configId }, 
                query: { classId: this.item.classIdArray.toString(), raceId: this.item.raceId }
            });
            window.open(routeData.href, '_blank');
        }
    },
    watch: {
        dialog(val) {
            if(!val) {
                this.bandEdit = false;
            } else if(!this.bandEdit) {
                if(this.$refs.formAddParticipant) {
                    this.$refs.formAddParticipant.reset();
                }
            }
        },
        bandReopen(val) {
            if(!val) {
                if(this.reopenEdition) {
                    this.dialog = true;
                }
            }
        }
    }
    
};
</script>
